import { useKeyPressEvent } from 'react-use'
import { KeyFilter } from 'react-use/lib/useKey'

export const OnKeyPressEvent = ({
  keyPress,
  action,
}: {
  keyPress: string | KeyFilter
  action: () => void | Promise<void>
}) => {
  useKeyPressEvent(keyPress, null, action)

  return null
}
